import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom Left Arrow
const PrevArrow = ({ onClick }) => {
  return (
    <div
      className="custom-arrow left-arrow"
      onClick={onClick}
      style={{
        position: 'absolute',
        left: '-15px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        cursor: 'pointer',
        background: "#C6AFFF",
        width: "30px",
        height: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%"
      }}
    >
      <i className="fa-solid fa-arrow-left"></i>
    </div>
  );
};

// Custom Right Arrow
const NextArrow = ({ onClick }) => {
  return (
    <div
      className="custom-arrow right-arrow"
      onClick={onClick}
      style={{
        position: 'absolute',
        right: '-15px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        cursor: 'pointer',
        background: "#C6AFFF",
        width: "30px",
        height: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%"
      }}
    >
      <i className="fa-solid fa-arrow-right"></i>
    </div>
  );
};

const BoxSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="relative w-[95%] lg:w-[90%] mx-auto px-4">
      <Slider {...settings}>
        {[...Array(6)].map((_, index) => (
          <div key={index} className="">
            <div
              className="rounded-xl bg-black w-[120px] h-[120px] md:w-[153px] md:h-[153px] mx-auto"
            ></div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BoxSlider;
